<template></template>

<script>
import IcFormContactBase from "./ContactBase";
import moment from "moment";

export default {
  name: "IcFormComplaintBase",
  extends: IcFormContactBase,
  created() {
  },
  data() {
    return {
      form: {
        pollAgreement: 0
      }
    };
  }
};
</script>

<style>
</style>
